import React from 'react';

/** 기존 학생 페이지와 같은 SID 원. 휴대폰은 24px, 데스크톱은 32px. */
export default function StudentIdBadge({ id, blocked = false, title, empty = '—' }) {
  return (
    <span
      title={title ?? (id == null ? 'SID 없음' : `SID ${id}${blocked ? ' · 로그인 잠김' : ''}`)}
      className={`inline-flex size-6 shrink-0 items-center justify-center rounded-full bg-gradient-to-r text-xs font-bold text-white md:size-8 ${String(id || '').length > 3 ? '' : 'md:text-sm'} ${blocked ? 'from-red-500 to-red-600' : 'from-primary to-primary/70'}`}
    >
      {id ?? empty}
    </span>
  );
}
